import { Component, Input } from '@angular/core';
import {
  AttributeValue,
  FormTypes,
} from '../../../../models/section-definition.model';

@Component({
  selector: 'lib-attribute-selected-options-row',
  standalone: false,
  templateUrl: './attribute-selected-options-row.component.html',
  styleUrls: ['./attribute-selected-options-row.component.scss'],
})
export class AttributeSelectedOptionsRowComponent {
  @Input() attributeValue!: AttributeValue;
  FormTypes = FormTypes;
}
